import * as ActionType from '../actions/user';
import UserState from "../../constants/UserState";
import Logger from "../../tools/logger";

const defaultState = {
	userState: null,
	isLoadingCreate: false
};

/**
 * @description
 * get the user data required for every page of the app.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function user (state = defaultState, action) {
	let newState = { ...state };

	switch (action.type) {
		case ActionType.REQUEST_GET : {
			newState.userState = UserState.LOADING;
			return newState;
		}

		case ActionType.SUCCESS_GET : {
			newState.profileData = action.payload;

			// log the login/load of the user
			Logger.instance.notice({
				component: 'load-user',
				message: `loaded user info for participant: ${newState.profileData.participantId}`
			});

			newState.profileData.countryCode = newState.profileData.languageCode;

			newState.userState = UserState.USER_LOADED;
			return newState;
		}

		case ActionType.FAILURE_GET : {
			newState.userState = UserState.ERROR_FETCHING;

			if (action.payload && action.payload.status !== 401) {
				Logger.instance.error({
					component: 'load-user',
					message: `error while loading user info for participant: ${newState.profileData.participantId}`
				});
			}

			return newState;
		}

		case ActionType.REQUEST_CREATE : {
			newState.isLoadingCreate = true;
			return newState;
		}

		case ActionType.SUCCESS_CREATE : {
			newState.isLoadingCreate = false;
			return newState;
		}

		case ActionType.FAILURE_CREATE : {
			newState.isLoadingCreate = false;
			return newState;
		}

		default:
			return state;
	}
}
